export default moment => moment.format('D MMM');



// WEBPACK FOOTER //
// ./src/javascripts/account/usage/committed/formatDate.es6.js